import { render, staticRenderFns } from "./dianbu.vue?vue&type=template&id=0bf1c44b&scoped=true&"
import script from "./dianbu.vue?vue&type=script&lang=js&"
export * from "./dianbu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1c44b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf1c44b')) {
      api.createRecord('0bf1c44b', component.options)
    } else {
      api.reload('0bf1c44b', component.options)
    }
    module.hot.accept("./dianbu.vue?vue&type=template&id=0bf1c44b&scoped=true&", function () {
      api.rerender('0bf1c44b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/bonusConfig/bounsCond/dianbu.vue"
export default component.exports